var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-step",class:_vm.customClass,style:(_vm.customStyle)},[_c('div',{staticClass:"custom-step__number",class:{ 'custom-step__number_filled': _vm.isFilled }},[_vm._v(_vm._s(_vm.number))]),_c('div',{staticClass:"custom-step__title",class:_vm.titleClass,style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.$t(_vm.title)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }